__webpack_require__.p = "/samridhi-portfolio/";